import React, { useState } from 'react';

const INTEGRATIONS = [
  { id:'zapier',    name:'Zapier',     category:'Automation', desc:'Connect TransferExpo to 5,000+ apps. Automate tasks without code.', connected:true,  color:'#FF4F00', icon:'⚡' },
  { id:'stripe',    name:'Stripe',     category:'Payments',   desc:'Process payments, manage subscriptions and view transaction data.', connected:true,  color:'#635BFF', icon:'💳' },
  { id:'mailchimp', name:'Mailchimp',  category:'Email',      desc:'Sync contacts and trigger email campaigns from CRM events.',       connected:false, color:'#FFE01B', icon:'🐒' },
  { id:'slack',     name:'Slack',      category:'Comms',      desc:'Get CRM notifications, deal alerts and activity updates in Slack.',connected:true,  color:'#4A154B', icon:'💬' },
  { id:'hubspot',   name:'HubSpot',    category:'CRM sync',   desc:'Two-way sync of contacts and deals between systems.',             connected:false, color:'#FF7A59', icon:'🔶' },
  { id:'google',    name:'Google Workspace',category:'Productivity',desc:'Sync contacts, calendar events and emails with Google.',    connected:true,  color:'#4285F4', icon:'📅' },
  { id:'typeform',  name:'Typeform',   category:'Forms',      desc:'Create beautiful forms and push responses directly to contacts.', connected:false, color:'#262627', icon:'📋' },
  { id:'intercom',  name:'Intercom',   category:'Support',    desc:'Sync support conversations and contact data bidirectionally.',    connected:false, color:'#1F8DED', icon:'💭' },
  { id:'mixpanel',  name:'Mixpanel',   category:'Analytics',  desc:'Push CRM events to Mixpanel for product analytics correlation.',  connected:false, color:'#7856FF', icon:'📊' },
  { id:'twilio',    name:'Twilio',     category:'SMS/Calls',  desc:'Send SMS and make calls directly through the CRM using Twilio.',  connected:true,  color:'#F22F46', icon:'📞' },
  { id:'notion',    name:'Notion',     category:'Docs',       desc:'Sync CRM notes and deal updates to Notion databases.',           connected:false, color:'#000000', icon:'📝' },
  { id:'linkedin',  name:'LinkedIn Sales Nav',category:'Prospecting',desc:'Pull LinkedIn data directly onto contact records.',       connected:false, color:'#0A66C2', icon:'🔗' },
];

const CATEGORIES = ['All','Automation','Payments','Email','Comms','CRM sync','Productivity','Forms','Support','Analytics','SMS/Calls','Docs','Prospecting'];
const ZAPIER_ZAPS = [
  { name:'New contact → Add to Mailchimp',  status:'Active', runs:1240 },
  { name:'Deal activated → Notify Slack',   status:'Active', runs:87   },
  { name:'New ticket → Create Asana task',  status:'Paused', runs:34   },
  { name:'Evaluation paid → Log in Sheets', status:'Active', runs:312  },
];

export default function Integrations({ toast }) {
  const [integrations, setIntegrations] = useState(INTEGRATIONS);
  const [filter, setFilter] = useState('All');
  const [showZaps, setShowZaps] = useState(false);

  const filtered = filter==='All'?integrations:integrations.filter(i=>i.category===filter);
  const connected = integrations.filter(i=>i.connected).length;

  const toggle = id => {
    setIntegrations(prev=>prev.map(i=>i.id===id?{...i,connected:!i.connected}:i));
    const int = integrations.find(i=>i.id===id);
    toast?.(int?.connected?`${int.name} disconnected`:`${int.name} connected successfully!`);
  };

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Connected</div><div className="stat-value" style={{ color:'var(--accent)' }}>{connected}</div><div className="stat-sub stat-up">Active integrations</div></div>
        <div className="stat-card"><div className="stat-label">Available</div><div className="stat-value">{integrations.length}</div><div className="stat-sub">Total integrations</div></div>
        <div className="stat-card"><div className="stat-label">Zapier zaps</div><div className="stat-value">{ZAPIER_ZAPS.filter(z=>z.status==='Active').length}</div><div className="stat-sub stat-up">Running</div></div>
        <div className="stat-card"><div className="stat-label">Data synced</div><div className="stat-value">5,159</div><div className="stat-sub stat-up">Contacts synced</div></div>
      </div>

      {showZaps && (
        <div className="card" style={{ marginBottom:16 }}>
          <div className="card-header"><span className="card-title">⚡ Active Zapier Zaps</span><button className="btn btn-ghost" style={{ fontSize:12 }} onClick={()=>setShowZaps(false)}>✕</button></div>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Zap name</th><th>Runs</th><th>Status</th><th>Action</th></tr></thead>
              <tbody>
                {ZAPIER_ZAPS.map((z,i)=>(
                  <tr key={i}>
                    <td style={{ fontWeight:500,fontSize:13 }}>{z.name}</td>
                    <td style={{ color:'var(--accent)',fontWeight:600 }}>{z.runs.toLocaleString()}</td>
                    <td><span className={z.status==='Active'?'badge badge-green':'badge badge-amber'}>{z.status}</span></td>
                    <td><button className="btn btn-ghost" style={{ fontSize:11,padding:'4px 10px' }} onClick={()=>toast?.('Opening Zapier...')}>Edit in Zapier ↗</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16,flexWrap:'wrap',gap:8 }}>
        <div className="filter-pills" style={{ marginBottom:0,flexWrap:'wrap' }}>
          {CATEGORIES.slice(0,8).map(c=><button key={c} className={`pill ${filter===c?'active':''}`} onClick={()=>setFilter(c)} style={{ fontSize:11 }}>{c}</button>)}
        </div>
        <button className="btn btn-ghost" onClick={()=>setShowZaps(v=>!v)}>⚡ View Zapier zaps</button>
      </div>

      <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:16 }}>
        {filtered.map(i=>(
          <div key={i.id} className="card">
            <div style={{ display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:12 }}>
              <div style={{ display:'flex',alignItems:'center',gap:10 }}>
                <div style={{ width:40,height:40,borderRadius:10,background:`${i.color}22`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20 }}>{i.icon}</div>
                <div>
                  <div style={{ fontWeight:600,fontSize:14,color:'var(--text-primary)' }}>{i.name}</div>
                  <div style={{ fontSize:10,color:'var(--text-dim)',padding:'1px 6px',borderRadius:99,background:'var(--bg-input)',display:'inline-block',marginTop:2 }}>{i.category}</div>
                </div>
              </div>
              <span className={i.connected?'badge badge-green':'badge badge-gray'}>{i.connected?'Connected':'Not connected'}</span>
            </div>
            <div style={{ fontSize:13,color:'var(--text-muted)',lineHeight:1.5,marginBottom:14 }}>{i.desc}</div>
            <button className={`btn ${i.connected?'btn-ghost':'btn-primary'}`} style={{ width:'100%',fontSize:12 }} onClick={()=>toggle(i.id)}>
              {i.connected?'Disconnect':'Connect'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
